export type BarcodeType = "EAN_13" | "EAN_8" | "UPC_A" | "UPC_E" | "GS1" | "UNKNOWN";

export function detectBarcodeType(code: string): BarcodeType {
  if (/^\d{13}$/.test(code)) return "EAN_13";
  if (/^\d{8}$/.test(code)) return "EAN_8";
  if (/^\d{12}$/.test(code)) return "UPC_A";
  if (/^\d{6,8}$/.test(code)) return "UPC_E";
  if (/^\(01\)\d{14}/.test(code)) return "GS1";
  return "UNKNOWN";
}

export function validateChecksumEAN13(code: string): boolean {
  if (!/^\d{13}$/.test(code)) return false;

  const digits = code.split("").map(Number);
  const checksum = digits.pop()!;
  const sum = digits.reduce(
    (acc, d, i) => acc + d * (i % 2 === 0 ? 1 : 3),
    0
  );

  return (10 - (sum % 10)) % 10 === checksum;
}

export function validateBarcode(code: string): {
  valid: boolean;
  type: BarcodeType;
  reason?: string;
} {
  const type = detectBarcodeType(code);

  if (type === "EAN_13" && !validateChecksumEAN13(code)) {
    return { valid: false, type, reason: "Invalid EAN-13 checksum" };
  }

  if (type === "UNKNOWN") {
    return { valid: false, type, reason: "Unsupported barcode format" };
  }

  return { valid: true, type };
}
